import { createContext } from 'react';

export const MapDataContext = createContext({});